import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ConfigModule, ProcessModule, StateConfig, StateTransferType } from '@spartacus/core';
import { reducerProvider, reducerToken } from './store/reducers';
import { REFERENCE_FEATURE } from './store/reference-state';

function referenceStoreConfigFactory(): StateConfig {
  return {
    state: {
      ssrTransfer: {
        keys: {
          [REFERENCE_FEATURE]: StateTransferType.TRANSFER_STATE,
        },
      },
    },
  };
}

@NgModule({
  imports: [
    ProcessModule.forRoot(),
    StoreModule.forFeature(REFERENCE_FEATURE, reducerToken),
    ConfigModule.withConfigFactory(referenceStoreConfigFactory),
  ],
  providers: [reducerProvider],
})
export class ReferenceDataAccessModule {}
